module.exports = __webpack_public_path__ + "img/hkLv1Cover.e82c2a98.png";